import { pm2ConfigStore } from '@pm2/store';
import { usePm2Modal } from '@pm2/ui-lightbox';
import { UniversalLightboxCard } from '@utils/component-framework';
import { PostloadedIframe } from '../../../molecules/embed-iframe/atom.postloaded-iframe.js';
import { Boundary } from '../../../molecules/embed-iframe/comp.boundary.js';
import { card } from './card.style.js';
import { jsx } from 'react/jsx-runtime';

function CardPreview(props) {
  const modal = usePm2Modal();
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const handleClick = () => {
    if (props.displayData && props.target === "_blank") {
      window.open(props.displayData.src, "_blank");
    } else if (props.displayData) {
      modal.fromContent(/*#__PURE__*/jsx(Boundary, {
        hasPreviewImage: false,
        previewImageDimensions: undefined,
        forceOpenInLightbox: false,
        displayData: props.displayData,
        inLightbox: true,
        children: /*#__PURE__*/jsx(PostloadedIframe, {
          src: props.displayData.src,
          title: props.title
        })
      }), {
        speechFile: undefined
      });
    } else {
      alert("Der opstod en fejl da vi forsøgte at åbne komponenten, vi beklager. Prøv at genindlæse siden.");
    }
  };
  return /*#__PURE__*/jsx(UniversalLightboxCard, {
    className: card,
    audience: audience,
    title: props.title,
    description: props.description,
    badgeImageSrc: props.badgeImage,
    previewImageSrc: props.previewImageSrc,
    indexOrLevel: props.indexOrLevel,
    onClick: handleClick
  });
}

export { CardPreview };
//# sourceMappingURL=card.js.map
